



















import { Component, Prop, Vue } from "vue-property-decorator";

import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import { Decks } from "../../store/modules/desk/types";
import DoKoStackCards from "./DoKoStackCards.vue";

@Component({ components: { DoKoStackCards } })
export default class DoKoStack extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  private placeName!: "bottom" | "left" | "top" | "right";

  @Getter(deskApi.getters.getDecks, { namespace: deskApi.namespace })
  decks!: Decks;

  get deckInfo() {
    return this.decks[this.placeName];
  }

  @Prop({
    type: Number,
    default: 1,
  })
  private scale!: number;

  get count() {
    return this.deckInfo.trickCount;
  }

  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  get cardPos() {
    return [
      { x: -50, y: 0, r: -5 },
      { x: -50, y: -15, r: 4 },
      { x: -50, y: -20, r: 0 },
      { x: -50, y: -24, r: 2 },
      { x: -45, y: -27, r: -5 },
      { x: -45, y: -30, r: -2 },
      { x: -48, y: -35, r: -4 },
      { x: -52, y: -42, r: -1 },
      { x: -50, y: -46, r: 3 },
      { x: -52, y: -50, r: -5 },
    ].slice(0, this.count);
  }

  get transformText() {
    return ` rotate(180) translate(${this.x} ${this.y})  scale(${this.scale})`;
  }
}
